import {
  setHint
} from 'website/src/js/registration/shared/functions.js';

export default class Password {
  constructor(args) {
    this.translations = translations.registrationForm;

    this.container = document.querySelector('.grid-x.password');
    this.passwordInput1 = this.container.querySelector('input[name="password"]');
    this.passwordInput2 = this.container.querySelector('input[name="confirm_password"]');
    this.password1hintOut = this.container.querySelector('.password-1 .hint');
    this.password2hintOut = this.container.querySelector('.password-2 .hint');

    this.setHint = setHint.bind(this);

    this.errorClass = 'invalid';

    this.addEvents();
  }

  addEvents() {
    [this.passwordInput1, this.passwordInput2].map(field => {
      field.addEventListener('change', e => {
        this.passwordInput1.classList.remove(this.errorClass);
        this.passwordInput2.classList.remove(this.errorClass);
        this.setHint(null, this.password1hintOut);
        this.setHint(null, this.password2hintOut);
      });
    });
  }

  validate() {
    const pass1Hints = [];
    const pass2Hints = [];
    const invalidFields = new Set();

    if (!this.passwordInput1.value.length) {
      pass1Hints.push({
        type: 'alert',
        text: this.translations.passwordEmptyError
      });
      invalidFields.add(this.passwordInput1);
    }

    if (this.passwordInput1.value.match(/\s/g) !== null) {
      pass1Hints.push({
        type: 'alert',
        text: this.translations.passwordWhitespacesError
      });
      invalidFields.add(this.passwordInput1);
    }

    if (this.passwordInput1.value.length && this.passwordInput1.value.length < 6) {
      pass1Hints.push({
        type: 'alert',
        text: this.translations.passwordLengthError
      });
      invalidFields.add(this.passwordInput1);
    }

    if (!this.passwordInput2.value.length) {
      pass2Hints.push({
        type: 'alert',
        text: this.translations.passwordRepetitionEmptyError
      });
      invalidFields.add(this.passwordInput2);
    }

    if (this.passwordInput1.value && this.passwordInput2.value && this.passwordInput1.value !== this.passwordInput2.value) {
      pass2Hints.push({
        type: 'alert',
        text: this.translations.passwordEqualityError
      });
      invalidFields.add(this.passwordInput2);
    }

    this.setHint(pass1Hints, this.password1hintOut);
    this.setHint(pass2Hints, this.password2hintOut);

    [...invalidFields].map(field => field.classList.add(this.errorClass));

    return invalidFields.size === 0;
  }
}